// extracted by mini-css-extract-plugin
export var parcelRow = "_vv-0";